import { render } from "./PhotoClassifyLineTinyView.vue?vue&type=template&id=6c880fdd&scoped=true"
import script from "./PhotoClassifyLineTinyView.vue?vue&type=script&lang=js"
export * from "./PhotoClassifyLineTinyView.vue?vue&type=script&lang=js"

import "./PhotoClassifyLineTinyView.vue?vue&type=style&index=0&id=6c880fdd&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c880fdd"]])

export default __exports__